
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.teaser-card{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
  padding:var(--spacing-8) 0;
  border-bottom:3px solid var(--brand-primary-dark-blue);
  font-family:var(--ff-display);
  --heading-color:var(--brand-primary-dark-blue);
}

.container{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-2);
}

.eyebrow{
  color:var(--brand-primary-dark-blue);
  font-size:var(--fs-headline-2xs-responsive);
  text-transform:uppercase;
}

.date{
  color:var(--brand-gray-900);
  font-size:var(--fs-sm);
  font-family:var(--ff-body);
}

.description{
  font-family:var(--ff-body);
}
`;